import { RadioGroup, RadioGroupItem } from "../ui/radio-group";
import { Label } from "../ui/label";

export const RadioGroups = (props) => {
  const {
    description = "",
    label = "",
    options = [],
    onChange,
    value,
    ...restProps
  } = props;

  const handleValueChange = (newValue) => {
    if (onChange) {
      // Convert string values back to their original types (boolean, undefined)
      let parsedValue = newValue;
      if (newValue === "true") parsedValue = true;
      else if (newValue === "false") parsedValue = false;
      else if (newValue === "") parsedValue = undefined;

      onChange({ target: { value: parsedValue } });
    }
  };

  return (
    <div className="space-y-3">
      {label ? <Label>{label}</Label> : null}
      <RadioGroup
        className="flex flex-row gap-4"
        onValueChange={handleValueChange}
        value={value !== undefined ? String(value) : ""}
        {...restProps}
      >
        {options.map(({ label, value = "" }) => {
          return (
            <div key={String(value)} className="flex items-center space-x-2">
              <RadioGroupItem value={String(value)} id={String(value)} />
              <Label
                htmlFor={String(value)}
                className="font-normal cursor-pointer"
              >
                {label}
              </Label>
            </div>
          );
        })}
      </RadioGroup>
      {description ? (
        <p className="text-xs text-muted-foreground">{description}</p>
      ) : null}
    </div>
  );
};

export default RadioGroups;
